export default {
  CONFIRM_DELETION_ALL: 'Confirm to delete all search records?',
  HOT_SEARCH: 'Hot search',
  RECENTLY_SEARCH: 'Recent search',
  NO_RECENT_SEARCH: 'No recent search',
  RECENT_SEARCH: 'Search'
};
